module.exports = __webpack_public_path__ + "static/icon_milano_sudest_grigio-1d7635cb65f05f14c6ad80a2e4da3792.svg";